import React from "react";
import Particle from "../../Components/Particle.js";
import Home2 from "./Home2";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import sliderConfig from '../../Assets/Slider';


function Home() {
  return (
    <section>
      <div className="home-section w-full" id="home">
        <Particle />
        <div className="flex flex-wrap">
          <div className="w-full home-header">
            <Carousel
              autoPlay={true}
              infiniteLoop={true}
              showThumbs={false}
              swipeable={true}
              interval={5000}
              stopOnHover={true}

            >
              {
                sliderConfig.map((item) => <div key={item.id}>
                  <img src={item.image} alt={item.id} />
                  {(item.heading || item.subheading) &&<div className="legend legendStyle">
                    <h4>{item.heading}</h4>
                    <p>{item.subheading}</p>
                  </div>}
                </div>)
              }
            </Carousel>
          </div>
        </div>
      </div>
  
      <Home2 />
    </section>
  );
}

export default Home;
